// Libs
import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { withRouter, RouteComponentProps} from 'react-router-dom'
import Button from "@material-ui/core/Button";
import Requests from 'src/lib/requests';
// Components
// import successBg from '../img/success.jpg'
import FABButton from '@material-ui/core/Button'
import ResetIcon from '@material-ui/icons/Replay'
// Store
import { resetJourney } from './duck/actions'
import { IProfileState } from '../lib/interface'


interface IProps extends RouteComponentProps<{}> {
  profile: IProfileState
  resetJourney: () => void
}

class Success extends React.Component<IProps, {}> {
  public state = {
    options: {
      background: '',
      header: ''
    }
  }
  public async componentDidMount() {
    localStorage.removeItem('viewsSelections')
    this.props.resetJourney()
    let options
    try {
      options = await Requests.getOptions();
      console.log(options)
    } catch (e) {
      console.log('error getting view',e)
    }

    // Structure the view data meaningfully and set to state
    if (options) {
      this.setState({options: {
        background: options.data.acf.success_page_background,
        header: options.data.acf.success_screen_headline
      } })
    } else {
      this.props.history.push('/views/new')
    }

  }
  
  public restartJourney = () => {
    this.props.history.push('/views/new')
  }

  public goToLandingPage = () => {
    const params: any = { ...this.props.match.params }
    this.props.history.push(`/view/${params.id}`)
  }
  public render() { 
    const Text = this.state.options.header // 'Your service discovery bundle has been generated.'
    const Image = this.state.options.background
    const Outer = styled.div`
      background-image: url(${Image});
      background-size: cover;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      h1 {
        padding: 50px;
        margin: 0px;
        color: #f9f9f9;
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.95px;
        font-size: 30px;
        font-weight: bold;
      }
    `
    return (
      <Outer>
        <h1>{Text}</h1>
        <Button onClick={this.goToLandingPage} 
        style={{
          backgroundColor: "#E4002B",
          fontWeight: 500,
          letterSpacing: "1px",
          color: '#fff',
          marginBottom: '50px'
        }}>
        View Journey</Button>
        <FABButton
        variant="fab"
        aria-label="restart"
        style={{
        backgroundColor: '#E4002B',
        color: '#fff'
        }}
        onClick={this.restartJourney}
    >
    <ResetIcon style={{ color: '#fff' }}/>
    </FABButton>
      </Outer>
    )
  }
}

const mapStateToProps = (state: any) => ({
  profile: state.profile
})

export default withRouter(connect(
  mapStateToProps,
  {resetJourney}
)(Success))


// WEBPACK FOOTER //
// ./src/views/Success.tsx